import axiosInstance from './axiosInstance';

const legalApi = {
    // Сохранение/обновление реквизитов юр. лица
    save: (data) => axiosInstance.post('/legal/save', data),

    // Получение реквизитов текущего юр. лица пользователя
    get: (userId) => axiosInstance.get(`/legal/get?userId=${userId}`),

    // Проверка существования юр. лица по ИНН
    checkInn: (inn) => axiosInstance.get(`/legal/check-inn?inn=${inn}`),

    // Отвязать юр. лицо от пользователя
    unlink: (userId, legalEntityId) => axiosInstance.post('/legal/unlink', { userId, legalEntityId }),

    // Получить информацию о доступном тарифе
    getPlanInfo: () => axiosInstance.get('/legal/plan-info'),

    // Оплата картой (через Робокассу)
    paymentCard: (userId, legalEntityId, planKey) =>
        axiosInstance.post('/legal/payment/card', { userId, legalEntityId, planKey }),

    // Оплата по счёту (безнал)
    paymentInvoice: (userId, legalEntityId, planKey) =>
        axiosInstance.post('/legal/payment/invoice', { userId, legalEntityId, planKey }),
};

export default legalApi;
